import { Fullscreen } from '@mui/icons-material';
import React from 'react';
import YouTube from 'react-youtube';

const UnlistedVideo = () => {
  const opts = {
    playerVars: {
      autoplay: 1,
      controls: 1,
      modestbranding: 1,
      rel: 0,
      showinfo: 0,
      disablekb: 1,
      fs: 1, // disable fullscreen button
    }
  };

  const onReady = (event) => {
    event.target.playVideo(); // autoplay when ready
  };

  return <YouTube videoId="e-9apt1nhms" opts={opts} onReady={onReady} />;
};

export default UnlistedVideo;